import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { PaymentErrorNotification, PaymentError } from '../../types/payment';

interface SyncPaymentErrorPayload {
  error: PaymentError;
  orderId: string;
  paymentId: string;
  userId?: string;
  userName?: string;
  tableNumber?: string;
}

interface MenuScrollState {
  scrollY: number;
  selectedCategory: number;
  timestamp: number;
}

interface UIState {
  isPageLoading: boolean;
  paymentError: PaymentErrorNotification | null;
  showPaymentErrorModal: boolean;
  isCartOpen: boolean;
  menuScrollState: MenuScrollState | null;
}

const initialState: UIState = {
  isPageLoading: false,
  paymentError: null,
  showPaymentErrorModal: false,
  isCartOpen: false,
  menuScrollState: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setPageLoading: (state, action: PayloadAction<boolean>) => {
      state.isPageLoading = action.payload;
    },
    setPaymentError: (state, action: PayloadAction<PaymentErrorNotification>) => {
      state.paymentError = action.payload;
      state.showPaymentErrorModal = true;
    },
    setSyncPaymentError: (state, action: PayloadAction<SyncPaymentErrorPayload>) => {
      const { error, orderId, paymentId, userId, userName, tableNumber } = action.payload;
      
      const errorNotification: PaymentErrorNotification = {
        type: 'PAYMENT_ERROR',
        source: 'sync',
        paymentId,
        orderId,
        userId: userId || 'guest',
        userName: userName || 'Usuario',
        tableNumber,
        error,
        timestamp: new Date().toISOString()
      };
      
      state.paymentError = errorNotification;
      state.showPaymentErrorModal = true;
    },
    clearPaymentError: (state) => {
      state.paymentError = null;
      state.showPaymentErrorModal = false;
    },
    hidePaymentErrorModal: (state) => {
      state.showPaymentErrorModal = false;
    },
    setCartOpen: (state, action: PayloadAction<boolean>) => {
      state.isCartOpen = action.payload;
    },
    setMenuScrollState: (state, action: PayloadAction<MenuScrollState>) => {
      state.menuScrollState = action.payload;
    },
    clearMenuScrollState: (state) => {
      state.menuScrollState = null;
    },
  },
});

export const { 
  setPageLoading, 
  setPaymentError, 
  setSyncPaymentError,
  clearPaymentError, 
  hidePaymentErrorModal,
  setCartOpen,
  setMenuScrollState,
  clearMenuScrollState
} = uiSlice.actions;

export type { SyncPaymentErrorPayload, MenuScrollState };
export default uiSlice.reducer;
